import { ITrackingData, IPiwikVisitedArticle, PiwikEvent, MetaEvent } from '../stores/types';

// eslint-disable-next-line no-var, @typescript-eslint/no-explicit-any
declare var _paq: any;
// eslint-disable-next-line no-var, @typescript-eslint/no-explicit-any
declare var _fbq: any;

class TrackingHelper {
    private piwikProEnableEcommerceTracking: boolean;
    private piwikEditModeOriginalSet: IPiwikVisitedArticle;
    private enableMetaPixel: boolean;
    private enableClientLogging: boolean;
    private basketItemId: string | null;
    private utm_campaign: string | null;
    private utm_medium: string | null;
    private utm_source: string | null;
    private utm_term: string | null;
    private utm_id: string | null;
    private testip: string | null;
    private itemOrigin: string | null;

    constructor(piwikProEnableEcommerceTracking: boolean, enableMetaPixel: boolean, enableClientLogging: boolean,
                basketItemId: string | null) {
        this.piwikProEnableEcommerceTracking = piwikProEnableEcommerceTracking;
        this.enableMetaPixel = enableMetaPixel;
        this.enableClientLogging = enableClientLogging;
        this.basketItemId = basketItemId;

        const searchParams = typeof window !== 'undefined' ?
            new URL(window.location.href).searchParams : null;
        if (searchParams) {
            this.utm_campaign = searchParams.get('utm_campaign');
            this.utm_medium = searchParams.get('utm_medium');
            this.utm_source = searchParams.get('utm_source');
            this.utm_term = searchParams.get('utm_term');
            this.utm_id = searchParams.get('utm_id');
            this.testip = searchParams.get('testip');
            this.itemOrigin = searchParams.get('itemOrigin');
        }
    }

    public piwikTrackVisitedArticle(data: ITrackingData, quantity: number, itemOrigin: string) {
        if (!this.piwikProEnableEcommerceTracking || typeof _paq === 'undefined') {
            if (this.enableClientLogging && this.piwikProEnableEcommerceTracking && typeof _paq === 'undefined') {
                // eslint-disable-next-line no-console
                console.warn('Piwik FT Enabled but _paq undefined');
            }
            return;
        }

        const trackedData: IPiwikVisitedArticle[] = [
            {
                sku: data.orderModule.flexSetInfo.fsCode,
                name: data.orderModule.flexSetInfo.displayName,
                category: data.category.navigationKeyPath.split('/'),
                price: data.orderModule.flexSetPrice.price.netValue.toFixed(2),
                variant: this.basketItemId,
                brand: '',
                customDimensions: {
                    '5': itemOrigin,
                },
                utm_campaign: this.utm_campaign,
                utm_medium: this.utm_medium,
                utm_source: this.utm_source,
                utm_term: this.utm_term,
                utm_id: this.utm_id,
                testip: this.testip,
                itemOrigin: itemOrigin,
            }
        ];

        if (itemOrigin && itemOrigin.toLowerCase() === 'basket') {
            this.piwikEditModeOriginalSet = trackedData[0];
            this.piwikEditModeOriginalSet.quantity = quantity;
        }

        _paq.push([PiwikEvent.EcommerceProductDetailView, trackedData]);
    }

    public piwikTrackRemovedArticle() {
        if (!this.piwikProEnableEcommerceTracking || typeof _paq === 'undefined' || !this.piwikEditModeOriginalSet) {
            if (this.enableClientLogging && this.piwikProEnableEcommerceTracking && typeof _paq === 'undefined') {
                // eslint-disable-next-line no-console
                console.warn('Piwik FT Enabled but _paq undefined');
            }
            return;
        }

        const trackedData = [
            {
                sku: this.piwikEditModeOriginalSet.sku,
                name: this.piwikEditModeOriginalSet.name,
                category: this.piwikEditModeOriginalSet.category,
                price: this.piwikEditModeOriginalSet.price,
                quantity: this.piwikEditModeOriginalSet.quantity,
                variant: this.piwikEditModeOriginalSet.variant,
                brand: this.piwikEditModeOriginalSet.brand,
                customDimensions: {
                    '5': this.piwikEditModeOriginalSet.customDimensions['5'],
                }
            }
        ];

        _paq.push([PiwikEvent.EcommerceRemoveFromCart, trackedData]);
    }

    public metaTrackVisitedArticle(data: ITrackingData) {
        if (!this.enableMetaPixel || typeof _fbq === 'undefined') {
            if (this.enableClientLogging && this.enableMetaPixel && typeof _paq === 'undefined') {
                // eslint-disable-next-line no-console
                console.warn('Meta FT Enabled but _fbq undefined');
            }
            return;
        }

        const trackedData = {
            content_name: data.orderModule.flexSetInfo.displayName,
            content_category: data.category.navigationKeyPath.split('/'),
            content_ids: [data.orderModule.flexSetInfo.fsCode],
            content_type: 'product',
            value: data.orderModule.flexSetPrice.price.grossValue.toFixed(2),
            currency: data.orderModule.flexSetPrice.currency.isoCode,
        };

        _fbq.push(['track', MetaEvent.ViewContent, trackedData]);
    }
}

export default TrackingHelper;
